import { useState } from "react"
import cc from "classcat"
import kebabCase from "lodash.kebabcase"
import Question from "components/atoms/common/Question"
import H3 from "components/atoms/H3"

export default function FAQ({ pairs, title = "", subtitle = "", theme }) {
  const [openedQuestions, setOpenedQuestion] = useState({})

  return (
    <div>
      {title ? (
        <H3 textStyle={theme} size="large" textAlign="left">
          {title}
        </H3>
      ) : null}
      {subtitle ? (
        <p
          className={cc([
            "max-w-lg text-xl leading-6",
            {
              "text-zinc-800": theme === "dark",
              "text-zinc-200": theme === "light",
            },
          ])}
        >
          {subtitle}
        </p>
      ) : null}
      <dl className="m-0 list-none divide-y-2 divide-kkm-green border-b-2 border-t-2 border-kkm-green">
        {pairs.map((pair, index) => (
          <Question
            theme={theme}
            key={kebabCase(`${pair.id}_${pair.question}_${index}`)}
            {...pair}
            active={openedQuestions[pair.id]}
            onClick={() => {
              setOpenedQuestion((oldState) => ({
                ...oldState,
                [pair.id]: !oldState[pair.id],
              }))
            }}
          />
        ))}
      </dl>
    </div>
  )
}
